import { EditOutlined } from '@ant-design/icons';
import { Paper } from '@mui/material';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { Button } from 'antd';
import MDBox from 'components/MDBox';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Confirmation } from 'schemas';
import { useRecoilState } from 'recoil';
import { GeneralFetch } from 'Api/generalFetch/generalFetch';

export default function PageHeader({ chips, selected, setSelected, showAddBtn = false, setFormData, formData, disabled }) {
    const navigate = useNavigate()
    const [isLocallyEnabled, setIsLocallyEnabled] = useState(false)
    const [loaclUpdate, setLocalUpdate] = useState(false)
    const chipDisabled = disabled && !isLocallyEnabled
    const [confirmation, setOpenConfirm] = useRecoilState(Confirmation)
    const { fetchData, loading } = GeneralFetch()

    const alertChange = () => setOpenConfirm({
        component: "updateCattegory",
        open: true,
        msg: "Tem certeza que deseja mudar a categoria desse registo?"
    })

    useEffect(() => {
        const fetchDataAsync = async () => fetchData(
            {
                ...formData,
                tipoReporte: selected,
            },
            `updateNearMiss/${formData?.objectId}`,
            'put',
            ''
        )

        if (confirmation.confirmed == true && confirmation?.component == "updateCattegory") {
            setLocalUpdate(false)
            void fetchDataAsync().then(() => {
                setSelected(loaclUpdate)
                setOpenConfirm({})
            })
        }

    }, [confirmation.confirmed])

    return (
        <div>
            {showAddBtn && <Button
                type="primary"
                icon={<EditOutlined />}
                size="middle"
                style={{ height: "36px", marginBottom: "10px" }}
                onClick={(e) => {
                    navigate('/reportar')
                }}
            >
                Reportar
            </Button>}
            <Paper elevation={1} >
                <MDBox
                    py={1.5}
                    px={2}
                    variant="gradient"
                    bgColor="white"
                    borderRadius="lg"
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
                        <Stack direction="row" flexWrap={"wrap"} spacing={1}>
                            {
                                chips.map((chip) => {
                                    return <Chip
                                        disabled={chipDisabled}
                                        size="medium"
                                        sx={{
                                            fontSize: "15px",
                                            fontWeight: "bold",
                                            borderRadius: "5px",
                                            margin: "1px",
                                            ...(chipDisabled ? { cursor: "not-allowed" } : {}),
                                            ...(chip.value === selected ? { background: "#72DDF7" } : { opacity: 0.6 }),
                                            "& .MuiChip-icon": {
                                                marginTop: "3px"
                                            }
                                        }}
                                        label={chip.label}
                                        onClick={() => {
                                            if (!disabled) {
                                                setSelected(chip.value)
                                                const { reportado_por, local_reporter, dataAcontecimento } = formData || {}
                                                if (setFormData) setFormData(() => ({
                                                    reportado_por, dataAcontecimento, local_reporter
                                                }))
                                            } else {
                                                setLocalUpdate(chip.value)
                                                alertChange()
                                            }
                                        }}
                                        icon={chip.icon}
                                    />
                                })
                            }
                        </Stack>
                        {disabled && (
                            <Button 
                                type="primary" 
                                loading={loading}
                                disabled={loading}
                                onClick={() => setIsLocallyEnabled(!isLocallyEnabled)}
                            >
                                {isLocallyEnabled ? "Cancelar" : "Mudar Categoria"}
                            </Button>
                        )}
                    </div>
                </MDBox>
            </Paper>
        </div>
    )
}